import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/features")({
	component: FeaturesLayout,
});

function FeaturesLayout() {
	return <Outlet />;
}
